import { UrlSegment, UrlMatchResult } from '@angular/router';

export const DemoRoutingMatcher = (url: UrlSegment[]): UrlMatchResult | null => {
    const consumed: UrlSegment[] = [];
    const posParams: { [key: string]: UrlSegment } = {};

    // Copy the url array to avoid having conflicts.
    const segments = url.slice();

    if (segments.length === 0) {
        return null;
    }

    const component = segments.at(-1).path.includes('-components');
    if (!component) {
        return null;
    }

    let params = [];

    params = ['type'];

    for (let i = 0; i < params.length; i++) {
        const param = params[i];
        const current = segments[i];

        consumed.push(current);
        posParams[param] = current;
    }

    return {
        consumed,
        posParams
    };
};
